import React from "react";
import ScheduleListItem from "./ScheduleListItem";
import CourseSchedule from "../../../Common/Models/CourseSchedule";
import SectionView from "../../../Common/Views/SectionView";

interface ScheduleSectionProps {
    schedules: CourseSchedule[];
}

export const ScheduleSection = (props: ScheduleSectionProps) => {
    const {schedules} = props;

    const displayScheduleItems = (schedules: CourseSchedule[]) =>
        schedules?.map((schedule, index) =>
            <ScheduleListItem key={index} schedule={schedule}/>
        );

    return (
        <SectionView title={"Schedule"}>
            {displayScheduleItems(schedules)}
        </SectionView>
    );
};